import * as types from './types'

const initialState = {
  layouts: {},
  currentBreakpoint: 'lg',
  toolbox: null,
  dashboards: null,
  currentDashboardId: null,
  savingLayout: false,
  editBreakpoint: 'lg',
  coursesOverview: [],
  coursesOverviewState: 'stale',
  coursesOverviewLoading: false,
  whereYouLeftFetched: false,
  whereYouLeftData: {
    width: 0,
    whereYouLeftUrl: '',
    lastActivity: [],
    lastCourseProgress: [],
    loadingActivity: false,
    loadingProgress: false,
  },
  coursesCompletedFetched: false,
  coursesCompletedData: {
    completedCourses: 0,
    allCompletedCourses: [],
    loading: false,
  },
  messagesFetched: false,
  managersOverviewFetched: false,
  managersOverview: {
    managersOverview: [],
    managersLoading: false,
  },
  rewardsFetched: false,
  rewardsData: {
    loading: false,
    storesWithRewards: [],
    selectedRewardRole: 'All',
    roleArray: [],
    userRewards: [],
    usersLoading: false,
    rewardsType: 'users',
  },
  restaurantProgressFetched: false,
  restaurantProgressData: {
    progressLoading: false,
    locations: [],
    locationRoles: [],
    selectedLocationsJobRole: '',
    tableList: null,
    locationRoleName: '',
    locationFilter: '',
    locationFilterWord: '',
    showLoadMore: false,
  },
  coursesOverviewsFetched: false,
  coursesOverviewsData: {
    coursesOverview: [],
    loadingCoursesOverview: false,
  },
  promotedCoursesFetched: false,
  promotedCoursesData: {
    promotedCourses: [],
    loadingPromotedCourses: false,
  },
  managerApprovalFetched: false,
  skipLocations: 0,

  // Add other initial state values here
}
const breakpoints = ['lg', 'md', 'sm']
function convertObjectDataTypes(obj) {
  const layout = { ...obj.layout }
  for (const key in layout) {
    if (key !== 'i') {
      const value =
        layout[key].toLowerCase && layout[key].toLowerCase() === 'false'
          ? false
          : Number(layout[key])
      layout[key] = isNaN(value) ? layout[key] : value
    }
  }
  return {
    ...obj,
    active:
      typeof obj.active === 'boolean'
        ? obj.active
        : obj.active
        ? obj.active.toString().toLowerCase() === 'true'
        : false,
    layout,
  }
}
const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_LAYOUTS':
      return { ...state, layouts: action.payload }
    case 'UPDATE_LAYOUT':
      const { newItem, currentBreakpoint, prevState } = action.payload
      const newLayouts = { ...prevState }

      const itemIndex = newLayouts[currentBreakpoint].findIndex(
        (layoutItem) => layoutItem.i == newItem.id
      )

      const convertedItem = convertObjectDataTypes(newItem)
      if (convertedItem.active) {
        // If the item is active, remove it from the layout
        if (itemIndex !== -1) {
          for (let i = 0; i < 3; i++) {
            newLayouts[breakpoints[i]] = prevState[breakpoints[i]].filter(
              ({ i }) => i !== convertedItem.id
            )
          }
        }
      } else {
        for (let i = 0; i < 3; i++) {
          newLayouts[breakpoints[i]] = [
            ...prevState[breakpoints[i]],
            convertedItem.layout,
          ]
        }
      }
      return { ...state, layouts: newLayouts }
    case 'SET_CURRENT_BREAKPOINT':
      return { ...state, currentBreakpoint: action.payload }
    case 'SET_EDIT_BREAKPOINT':
      return { ...state, editBreakpoint: action.payload }
    case 'SET_TOOLBOX':
      return { ...state, toolbox: action.payload }
    case 'SET_DASHBOARDS':
      return { ...state, dashboards: action.payload }
    case 'SET_CURRENT_DASHBOARD_ID':
      return { ...state, currentDashboardId: action.payload }
    case 'SET_SAVING_LAYOUT':
      return { ...state, savingLayout: action.payload }

    case types.SET_WHERE_YOU_LEFT_FETCHED:
      return { ...state, whereYouLeftFetched: action.payload }

    case types.SET_WHERE_YOU_LEFT_DATA:
      return {
        ...state,
        whereYouLeftData: {
          ...state.whereYouLeftData,
          ...action.payload,
        },
      }

    case types.SET_COMPLETED_COURSES_FETCHED:
      return { ...state, coursesCompletedFetched: action.payload }

    case types.SET_MESSAGES_FETCHED:
      return { ...state, messagesFetched: action.payload }

    case types.SET_COMPLETED_COURSES:
      return {
        ...state,
        coursesCompletedData: {
          ...state.coursesCompletedData,
          ...action.payload,
        },
      }

    case types.SET_MANAGERS_OVERVIEW_FETCHED:
      return { ...state, managersOverviewFetched: action.payload }

    case types.SET_MANAGERS_OVERVIEW:
      return {
        ...state,
        managersOverview: {
          ...state.managersOverview,
          ...action.payload,
        },
      }

    case types.SET_REWARDS_FETCHED:
      return { ...state, rewardsFetched: action.payload }

    case types.SET_REWARDS:
      return {
        ...state,
        rewardsData: {
          ...state.rewardsData,
          ...action.payload,
        },
      }

    case types.SET_RESTAURANT_PROGRESS_FETCHED:
      return { ...state, restaurantProgressFetched: action.payload }

    case types.SET_SKIP_LOCATIONS:
      return {
        ...state,
        skipLocations: state.skipLocations + 5,
      }

    case types.SET_SPECIFIC_SKIP_LOCATIONS:
      return {
        ...state,
        skipLocations: action.payload,
      }

    case types.RESET_SKIP:
      return {
        ...state,
        skipLocations: 0,
      }

    case types.SET_RESTAURANT_PROGRESS:
      return {
        ...state,
        restaurantProgressData: {
          ...state.restaurantProgressData,
          ...action.payload,
        },
      }

    case types.SET_PROMOTED_COURSES:
      return {
        ...state,
        promotedCoursesData: {
          ...state.promotedCoursesData,
          ...action.payload,
        },
      }

    case types.SET_COURSES_OVERVIEW_FETCHED:
      return { ...state, coursesOverviewsFetched: action.payload }

    case types.SET_PROMOTED_COURSES_FETCHED:
      return { ...state, promotedCoursesFetched: action.payload }

    case types.SET_MANAGER_APPROVAL_FETCHED:
      return { ...state, managerApprovalFetched: action.payload }

    case types.SET_COURSES_OVERVIEW:
      return {
        ...state,
        coursesOverviewsData: {
          ...state.coursesOverviewsData,
          ...action.payload,
        },
      }

    // case types.SET_COURSES_OVERVIEW:
    //   return {
    //     ...state,
    //     coursesOverview: action.payload,
    //     coursesOverviewLoading: false,
    //   }
    case types.SET_COURSES_OVERVIEW_LOADING:
      return { ...state, coursesOverviewLoading: true }
    case types.SET_COURSES_OVERVIEW_STALE:
      return { ...state, coursesOverviewState: 'stale' }
    case types.SET_COURSES_OVERVIEW_FRESH:
      return { ...state, coursesOverviewState: 'fresh' }

    default:
      return state
  }
}

export default dashboardReducer
